import React, { Component } from "react";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Divider from "@material-ui/core/Divider";
import Button from "@material-ui/core/Button";
import FormGroup from "@material-ui/core/FormGroup";
import Tooltip from "@material-ui/core/Tooltip";
import TextField from "@material-ui/core/TextField";
import TablePagination from "@material-ui/core/TablePagination";
import TableHead from "@material-ui/core/TableHead";
import { withStyles } from "@material-ui/core/styles";
import { withTranslation } from "react-i18next";
import { ROWS_PER_PAGE_OPTIONS } from "../components/Constants";
import { getErrorString } from "../display/ErrorStrings";
import CustomTableHead from "../components/CustomTableHead";
import ItemDetails from "../details/ItemDetails";
import PopupMessage from "../components/PopupMessage";
import ViewPdf from "../components/ViewPdf";
import CustomPaginatorActions from "../components/CustomPaginatorActions";
import downloadjs from "downloadjs";
import BigInteger from "big-integer";

import SearchIcon from "@material-ui/icons/PageviewOutlined";

import { AmountFormatCustom } from "../components/AmountFormatCustom";

const MAX_SEARCH_CNT = 1000;

const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },

  boldCell: {
    fontWeight: "bold",
    fontSize: 14,
  },
  summaryTable: {
    width: 600,
    border: "0px solid black",
    margin: "20px",
  },
  tableRow: {
    "&:hover": {
      backgroundColor: "secondary",
      cursor: "pointer",
    },
  },
});

const columnData = [
  { id: "1", numeric: false, disablePadding: false, label: "Issue Date" },
  { id: "2", numeric: false, disablePadding: false, label: "Presented Date" },
  { id: "3", numeric: false, disablePadding: false, label: "Check No." },
  { id: "4", numeric: false, disablePadding: false, label: "Status" },
  { id: "5", numeric: false, disablePadding: false, label: "Issue Payee" },
  {
    id: "6",
    numeric: true,
    disablePadding: false,
    label: "Presented Amount($)",
  },
  { id: "7", numeric: true, disablePadding: false, label: "Issue Amount($)" },
];

class SearchAccountItemsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorString: "",
      notifyString: "",
      checkFrom: "",
      checkTo: "",
      amountFrom: "",
      amountTo: "",
      items: [],
      summary: [],
      selectedItemId: 0,
      totalAmount: "",
      selectedItemObject: {},
      order: "asc",
      orderBy: "0",
      page: 0,
      rowsPerPage: window.sco_large_items_per_page,
      totalCount: 0,
      canSearch: false,
      waitingDownload: false,
      validated: false,
      viewPdf: false,
      viewPopup: false,
    };
    this.onClosePopup = this.onClosePopup.bind(this);
  }

  handleChange(e) {
    e.preventDefault();
    this.props.onReportChange(e);
  }

  componentDidUpdate() {
    if (this.state.waitingDownload && this.state.validated) {
      this.setState({ validated: false });
      this.setState({ waitingDownload: false });
      let myUrl = this.getUrl(
        "on_download_file",
        this.state.rowsPerPage,
        this.state.page,
        this.state.order,
        this.state.orderBy,
        true
      );
      this.downloadFile(myUrl, true);
    }
  }

  disableSearch() {
    this.setState({ canSearch: false });
    this.setState({ totalCount: 0 });
    this.setState({ page: 0 });
  }

  handleSearch(e) {
    if (!this.validateData()) {
      return;
    }
    this.setState({ canSearch: true });
    let myUrl = this.getUrl(
      "on_search_account_items_request",
      this.state.rowsPerPage,
      this.state.page,
      this.state.order,
      this.state.orderBy,
      false
    );
    this.search(
      myUrl,
      this.state.rowsPerPage,
      this.state.page,
      this.state.order,
      this.state.orderBy,
      false
    );
  }

  handlePdf(e) {
    if (!this.validateData()) {
      return;
    }
    this.setState({ viewPdf: true });
  }

  handleDownload(e) {
    if (!this.validateData()) {
      return;
    }
    this.setState({ waitingDownload: true });
    this.setState({ validated: false });
    let myUrl = this.getUrl(
      "on_search_account_items_request",
      this.state.rowsPerPage,
      this.state.page,
      this.state.order,
      this.state.orderBy,
      true
    );
    this.search(
      myUrl,
      this.state.rowsPerPage,
      this.state.page,
      this.state.order,
      this.state.orderBy,
      true
    );
  }

  validateData() {
    // alow only MAX_SEARCH_CNT checks for search
    let chS = this.state.checkFrom;
    let chE = this.state.checkTo;
    if (chS === "") {
      this.setState({
        errorString: getErrorString(
          "search.checkNumberStart.error",
          "Check Number start is required."
        ),
      });
      this.setState({ viewPopup: true });
      return false;
    }
    /*if (chE == "") {
			this.setState({ errorString: getErrorString('search.checkNumberEnd.error', 'Check Number end is required.') });
			this.setState({ viewPopup: true });
			return false;
		}*/
    if (chE !== "") {
      if (BigInteger(chE) - BigInteger(chS) > MAX_SEARCH_CNT) {
        this.setState({
          errorString: getErrorString(
            "search.checkNumberRange.error",
            "Maximum check number range cannot exceed " + MAX_SEARCH_CNT + "."
          ),
        });
        this.setState({ viewPopup: true });
        return false;
      }
      if (BigInteger(chE) < BigInteger(chS)) {
        this.setState({
          errorString: getErrorString(
            "search.checkNumberRangeValid.error",
            "Maximum check number should be higher than minimum check number."
          ),
        });
        this.setState({ viewPopup: true });
        return false;
      }
    }

    let amountS = this.state.amountFrom;
    let amountE = this.state.amountTo;
    if (amountS !== "" && amountE !== "") {
      if (parseFloat(amountS) > parseFloat(amountE)) {
        this.setState({
          errorString: getErrorString(
            "search.amountRange.error",
            "Maximum amount should be higher than minimum amount."
          ),
        });
        this.setState({ viewPopup: true });
        return false;
      }
    }
    return true;
  }

  downloadFile(myUrl, validate) {
    let validateOnly = validate === true ? "yes" : null;
    let sortorder = this.state.order === "asc" ? 1 : 2;
    fetch(myUrl, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        r: new Date().getTime(),
        secureToken: this.props.secureToken,
        transit: this.props.accountObject.transit,
        account: this.props.accountObject.account,
        option: this.props.option.id,
        sortorder: sortorder,
        sorttype: this.state.orderBy,
        checkFrom: this.state.checkFrom,
        checkTo: this.state.checkTo,
        amountFrom: this.state.amountFrom,
        amountTo: this.state.amountTo,
        rowsPerPage: this.state.rowsPerPage,
        page: this.state.page,
        validateOnly: validateOnly,
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.blob())
      .then((blob) => {
        downloadjs(blob, "itemfile.zip", "application/zip");
      })
      .catch((error) => {
        this.setState({
          errorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
        this.setState({ viewPopup: true });
      });
  }

  handleCheckFrom(e) {
    this.disableSearch();
    this.setState({ checkFrom: e.target.value });
  }

  handleCheckTo(e) {
    this.disableSearch();
    this.setState({ checkTo: e.target.value });
  }

  handleAmountFrom(e) {
    this.disableSearch();
    this.setState({ amountFrom: e.target.value });
  }

  handleAmountTo(e) {
    this.disableSearch();
    this.setState({ amountTo: e.target.value });
  }

  handleChangeRowsPerPage(e) {
    this.setState({ rowsPerPage: e.target.value });
    this.setState({ page: 0 });
    window.sco_large_items_per_page = e.target.value;
    if (this.state.canSearch) {
      let myUrl = this.getUrl(
        "on_search_account_items_request",
        e.target.value,
        0,
        this.state.order,
        this.state.orderBy,
        false
      );
      this.search(
        myUrl,
        e.target.value,
        0,
        this.state.order,
        this.state.orderBy,
        false
      );
    }
  }

  handleChangePage = (event, page) => {
    this.setState({ page: page });
    if (this.state.canSearch) {
      let myUrl = this.getUrl(
        "on_search_account_items_request",
        this.state.rowsPerPage,
        page,
        this.state.order,
        this.state.orderBy,
        false
      );
      this.search(
        myUrl,
        this.state.rowsPerPage,
        page,
        this.state.order,
        this.state.orderBy,
        false
      );
    }
  };

  handleRequestSort = (event, property) => {
    if (property.indexOf("nosort") !== -1) {
      return;
    }
    const orderBy = property;
    let order = "desc";
    if (this.state.orderBy === property) {
      if (this.state.order === "desc") {
        order = "asc";
      }
    } else {
      order = this.state.order;
    }
    this.setState({ order, orderBy });
    let myUrl = this.getUrl(
      "on_search_account_items_request",
      this.state.rowsPerPage,
      this.state.page,
      order,
      orderBy,
      false
    );
    this.search(
      myUrl,
      this.state.rowsPerPage,
      this.state.page,
      order,
      orderBy,
      false
    );
  };

  handleSelectItem(event, itemKey) {
    this.setState({ selectedItemObject: this.state.items[itemKey - 1] });
    this.setState({ selectedItemId: itemKey });
  }

  getUrl(requestType, curRowsPerPage, curPage, order, orderBy, validateOnly) {
    return requestType;
    /*let myUrl = this.getBaseUrl(requestType, order, orderBy) +
			'&r=' + new Date().getTime() +
			'&token=' + this.props.secureToken +
			'&rowsPerPage=' + curRowsPerPage +
			'&page=' + curPage;
		if (validateOnly) {
			myUrl += '&validateOnly=yes'
		}
		return myUrl;*/
  }

  getBaseUrl(requestType, order, orderBy) {
    return requestType;
    /*let sortorder = order === 'asc' ? 1 : 2;
		let baseUrl = requestType + '?transit=' +
			this.props.accountObject.transit +
			'&account=' + this.props.accountObject.account +
			'&sortorder=' + sortorder +
			'&sorttype=' + orderBy;
		if (this.state.checkFrom.length > 0) {
			baseUrl += "&checkFrom=" + encodeURIComponent(this.state.checkFrom);
		}
		if (this.state.checkTo.length > 0) {
			baseUrl += "&checkTo=" + encodeURIComponent(this.state.checkTo);
		}
		if (this.state.amountFrom.length > 0) {
			baseUrl += "&amountFrom=" + encodeURIComponent(this.state.amountFrom);
		}
		if (this.state.amountTo.length > 0) {
			baseUrl += "&amountTo=" + encodeURIComponent(this.state.amountTo);
		}
		return baseUrl;*/
  }

  onClosePopup(e) {
    this.setState({ viewPopup: false });
    this.setState({ viewPdf: false });
    this.setState({ waitingDownload: false });
    this.setState({ errorString: "" });
    this.setState({ notifyString: "" });
    this.setState({ selectedItemId: 0 });
  }

  search(myUrl, rowsPerPage, page, order, orderBy, validate) {
    let validateOnly = validate === true ? "yes" : null;
    let sortorder = order === "asc" ? 1 : 2;
    fetch(myUrl, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        r: new Date().getTime(),
        secureToken: this.props.secureToken,
        transit: this.props.accountObject.transit,
        account: this.props.accountObject.account,
        //'option': this.props.option.id,
        sortorder: sortorder,
        sorttype: orderBy,
        checkFrom: this.state.checkFrom,
        checkTo: this.state.checkTo,
        amountFrom: this.state.amountFrom,
        amountTo: this.state.amountTo,
        rowsPerPage: rowsPerPage,
        page: page,
        validateOnly: validateOnly,
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (reply.authenticated === false) {
          this.props.history.push("/expired");
        } else {
          if (reply.error) {
            this.setState({ errorString: reply.errorString });
            this.setState({ viewPopup: true });
          } else {
            if (validate) {
              this.setState({ validated: true });
            } else {
              let newItems = reply.items;
              this.setState({ items: newItems });
              this.setState({ totalCount: reply.totalCount });
              this.setState({ summary: reply.summary });
              if (reply.totalCount === 0) {
                this.setState({ viewPopup: true });
                this.setState({
                  notifyString: getErrorString(
                    "general.info.search.empty",
                    "Total number of items is 0."
                  ),
                });
              }
            }
          }
        }
      })
      .catch((error) => {
        this.setState({
          errorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
        this.setState({ viewPopup: true });
      });
  }

  isSelected = (id) => this.state.selectedItemId === id;

  render() {
    const { classes } = this.props;
    let { t } = this.props;
    const { order, orderBy, rowsPerPage, page, totalCount } = this.state;
    const actionTopMargin = 0;
    let data = this.state.items;
    let summary = this.state.summary;
    let myPdfUrl = this.getBaseUrl(
      "on_search_account_items_pdf_request",
      this.state.order,
      this.state.orderBy
    );
    return (
      <div>
        {this.state.viewPdf && (
          <ViewPdf
            history={this.props.history}
            secureToken={this.props.secureToken}
            onClosePopup={this.onClosePopup}
            pdfUrl={myPdfUrl}
            page={page}
            rowsPerPage={rowsPerPage}
          />
        )}
        {this.state.viewPopup && this.state.errorString.length > 0 && (
          <PopupMessage
            title="Error"
            text={this.state.errorString}
            error={true}
            onClosePopup={this.onClosePopup}
          />
        )}
        {this.state.viewPopup && this.state.notifyString.length > 0 && (
          <PopupMessage
            title={getErrorString("general.info.title", "Information")}
            text={this.state.notifyString}
            error={false}
            onClosePopup={this.onClosePopup}
          />
        )}
        {this.state.selectedItemId !== 0 && (
          <div>
            <ItemDetails
              item={this.state.selectedItemObject}
              history={this.props.history}
              uiExclusionsList={this.props.uiExclusionsList}
              viewOnly={this.props.viewOnly}
              secureToken={this.props.secureToken}
              accountObject={this.props.accountObject}
              onClosePopup={this.onClosePopup}
              option={this.state.selectedOption}
              onAction={this.onSelectedAction}
              canDelete={this.state.canDelete}
              canEdit={this.state.canEdit}
            />
          </div>
        )}
        {this.state.selectedItemId === 0 && (
          <div>
            {this.state.selectedItemId === 0 && (
              <div>
                <Paper elevation={5}>
                  <FormGroup row>
                    <TextField
                      margin="dense"
                      id="checkFrom"
                      label={"*" + t("checkNoFrom.label")}
                      type="text"
                      defaultValue={this.state.checkFrom}
                      onChange={(event) => this.handleCheckFrom(event)}
                      onKeyPress={(event) => {
                        return event.charCode >= 48 && event.charCode <= 57
                          ? true
                          : event.preventDefault();
                      }}
                    />
                    &nbsp;&nbsp;
                    <Tooltip title={t("leaveCheckEmpty.tip")}>
                      <TextField
                        margin="dense"
                        id="checkTo"
                        label={t("checkNoTo.label")}
                        type="text"
                        defaultValue={this.state.checkTo}
                        onChange={(event) => this.handleCheckTo(event)}
                        onKeyPress={(event) => {
                          return event.charCode >= 48 && event.charCode <= 57
                            ? true
                            : event.preventDefault();
                        }}
                      />
                    </Tooltip>
                    &nbsp;&nbsp;
                    <Tooltip title={t("amountRange.tip")}>
                      <TextField
                        margin="dense"
                        id="amountFrom"
                        label={t("filterAmountFrom.label")}
                        type="text"
                        defaultValue={this.state.amountFrom}
                        onChange={(event) => this.handleAmountFrom(event)}
                        InputProps={{
                          inputComponent: AmountFormatCustom,
                        }}
                      />
                    </Tooltip>
                    &nbsp;&nbsp;
                    <Tooltip title={t("amountRange.tip")}>
                      <TextField
                        margin="dense"
                        id="amountTo"
                        label={t("filterAmountTo.label")}
                        type="text"
                        defaultValue={this.state.amountTo}
                        onChange={(event) => this.handleAmountTo(event)}
                        InputProps={{
                          inputComponent: AmountFormatCustom,
                        }}
                      />
                    </Tooltip>
                    &nbsp;&nbsp;
                    <Tooltip title={t("showSearchResults.tip")}>
                      <Button
                        color="primary"
                        style={{ marginTop: actionTopMargin }}
                        onClick={(event) => this.handleSearch(event)}
                      >
                        <SearchIcon />
                        &nbsp;{t("search.button")}
                      </Button>
                    </Tooltip>
                  </FormGroup>
                </Paper>
              </div>
            )}
            <Divider />
            <TablePagination
              component="div"
              count={totalCount}
              rowsPerPage={rowsPerPage}
              rowsPerPageOptions={ROWS_PER_PAGE_OPTIONS}
              page={page}
              onChangePage={this.handleChangePage}
              onChangeRowsPerPage={(event) =>
                this.handleChangeRowsPerPage(event)
              }
              ActionsComponent={CustomPaginatorActions}
            />
            {this.state.canSearch &&
              this.state.selectedItemId === 0 &&
              this.state.totalCount > 0 && (
                <Paper elevation={5}>
                  <Table
                    className={classes.table}
                    aria-labelledby="tableTitle"
                    stickyHeader
                  >
                    <CustomTableHead
                      order={order}
                      orderBy={orderBy}
                      columnData={columnData}
                      onRequestSort={this.handleRequestSort}
                    />
                    <TableBody>
                      {data.map((n) => {
                        const isSelected = this.isSelected(n.index);
                        return (
                          <TableRow
                            hover
                            className={classes.tableRow}
                            onClick={(event) =>
                              this.handleSelectItem(event, n.index)
                            }
                            key={n.index}
                            selected={isSelected}
                            title={t("viewDetail.label")}
                          >
                            <TableCell style={{ width: "10%" }}>
                              {n.issueDate}
                            </TableCell>
                            <TableCell style={{ width: "12%" }}>
                              {n.paidDate}
                            </TableCell>
                            <TableCell style={{ width: "10%" }}>
                              {n.checkNumber}
                            </TableCell>
                            <TableCell style={{ width: "16%" }}>
                              {n.status}
                            </TableCell>
                            <TableCell
                              style={{ width: "28%", wordWrap: "break-word" }}
                            >
                              {n.payee}
                            </TableCell>
                            <TableCell numeric={true} style={{ width: "12%" }}>
                              {n.paidAmount}
                            </TableCell>
                            <TableCell numeric={true} style={{ width: "12%" }}>
                              {n.issueAmount}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </Paper>
              )}
            {this.state.canSearch && this.state.summary.length > 0 && (
              <Paper elevation={5}>
                <br />
                <p> &nbsp;&nbsp;{t("summary.label")}</p>
                <Table className={classes.summaryTable} stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell style={{ width: "30%" }}>
                        {t("type.label")}
                      </TableCell>
                      <TableCell style={{ width: "10%" }}>
                        {t("count.header")}
                      </TableCell>
                      <TableCell style={{ width: "10%" }}>
                        {t("amount.header")}
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {summary.map((n) => {
                      return (
                        <TableRow key={n.type}>
                          <TableCell style={{ width: "30%" }}>
                            {n.type}
                          </TableCell>
                          <TableCell style={{ width: "10%" }}>
                            {n.count}
                          </TableCell>
                          <TableCell style={{ width: "10%" }} numeric={true}>
                            {n.amount}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
                <br />
                <br />
                <br />
              </Paper>
            )}
          </div>
        )}
      </div>
    );
  }
}

export default withTranslation()(withStyles(styles)(SearchAccountItemsPage));
